import React, { Component } from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/Director/Utils/_utils/data';
import { TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';
import { OMCList } from '@C/Director/Utils/_utils/OMCList';

const col = [
  {
    name: 'Fuel name',
    key: 'product',
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['DIRECTOR'],
  },
  // {
  //   action: 'Edit',
  //   roles: ['DIRECTOR'],
  // },
];

export default class FuelList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fuelList: [],
      omc_id: '',
      loading: true,
      limit: 20,
      offset: 1,
      count: 0,
      OMCLists: [],
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getOMCList();
  }

  getOMCList = () => {
    services
      .getOMCList()
      .then((response) => {
        const tmp = response.data.data;
        const CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].omc,
          });
        }
        this.setState(
          {
            OMCLists: CategoryOptions,
            omc_id: CategoryOptions[0].value,
          },
          function () {
            this.getFuelList();
          },
        );
      })

      .catch((error) => {
        console.log(error);
      });
  };

  getFuelList = () => {
    const { omc_id } = this.state;
    services
      .getFuelList(omc_id)
      .then((response) => {
        this.setState({
          fuelList: response.data.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleOMCChange = (e) => {
    this.setState({ omc_id: e }, function () {
      this.getFuelList();
    });
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm Fuel deletion',
      message: (
        <div>
          Are you sure you want to delete the <span>"{item.product}"</span>
        </div>
      ),
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader();
    axios
      .delete(
        `${process.env.API_URL}/bunk/omc/product/?product_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Fuel deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getFuelList();
      });
  };

  render() {
    const { fuelList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header>
          <h3>Fuel List </h3>
        </header>
        <main className="list-content">
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>OMC:</label>
                <OMCList
                  handleOMCChange={this.handleOMCChange}
                  value={this.state.omc_id}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={fuelList}
                      pagination="disabled"
                      enableExport={false}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}
